/**
 * Usage events that identify a consuming treatment cycle. The origin cycle
 * remains on the specimen's top-level cycleId; these events represent later
 * reservation and lifecycle relationships.
 */
export const CONSUMING_SPECIMEN_USAGES: ReadonlySet<string> = new Set([
  "reserve",
  "thaw",
  "use",
  "transfer",
  "fertilize",
]);
